export default __webpack_public_path__ + "static/media/ban1.8691f6d6.jpg";